import { slugRequest } from '../slugRequest';
import { tokenObj } from '@/js/tokenParams.js';
import {
  gzhTestBaseUrl as testUrl,
  gzhBaseUrl as baseUrl,
} from '@/config/api';

const loginType = 4;

const { openid } = tokenObj;
const siteId = openid && /[a-z]/.test(openid) ? 12 : 13;

/**
 * 获取福利站任务
 * @return {Promise<*|undefined>}
 */
export const getPointTaskList = async (params: any) => {
  const path = '/point-wall/api/task/list';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

export const getGoods = async (params: any) => {
  const path = '/point-wall/api/goods/list';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

/**
 * 获取已有多少人领取了奖品
 * @return {Promise<*|undefined>}
 */
export const getStatistic = async (params: any) => {
  const path = '/point-wall/api/order/statistic';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

/**
 * 获取用户积分信息
 * @return {Promise<*|undefined>}
 */
export const getUserProfile = async (params: any) => {
  const path = 'point-wall/api/user/profile';

  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

/**
 * 获取跨界福利站全部列表
 * @return {Promise<*|undefined>}
 */
export const getLottery = async (params: any) => {
  const path = '/point-wall/api/lottery/config/list';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

/**
 * 获取抽奖详情
 * @return {Promise<*|undefined>}
 */
export const getLotteryDetail = async (params: any) => {
  const path = '/point-wall/api/lottery/config';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
  };

  return slugRequest(conf);
};

/**
 * 兑换奖励
 * @return {Promise<*|undefined>}
 */
export const exchangeGoods = async (params: any, data: any) => {
  const path = '/point-wall/api/order/exchange';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'POST',
    underlizeQuery: false,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
    data,
  };

  return slugRequest(conf);
};

/**
 * 做任务，页面维度
 * @return {Promise<*|undefined>}
 */
export const doPageTask = async (params: any, data: any) => {
  const path = '/point-wall/api/task/do_event_task';
  const conf = {
    testUrl: `${testUrl}/point-wall-pre${path}`,
    baseUrl,
    path,
    isAuth: true,
    source: 'backEnd',
    type: 'api',
    method: 'POST',
    underlizeQuery: false,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    query: Object.assign(
      {
        site_id: siteId,
        login_type: loginType,
      },
      params,
    ),
    data,
  };

  return slugRequest(conf);
};
